import {
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/pharmacists/Dashboard";
import MainLayout from "./layouts/MainLayout";
import Patients from "./pages/pharmacists/Patients/Patients";
import AddPatients from "./pages/pharmacists/Patients/AddPatients";
import ViewProfile from "./pages/pharmacists/ViewProfile/ViewProfile";
import Pharmacies from "./pages/pharmacists/Pharmacies/Pharmacies";
import AddPharmacy from "./pages/pharmacists/Pharmacies/AddPharmacy";
import ViewProfilePharmacies from "./pages/pharmacists/Pharmacies/ViewProfilePharmacies";
import Blogs from "./pages/pharmacists/Blogs/Blogs";
import Pharmacists from "./pages/pharmacists/Pharmacists/Pharmacists";
import Medicines from "./pages/pharmacists/Medicines/Medicines";
import AdminsList from "./pages/pharmacists/AdminsList/AdminsList";
import Unauthorized from "./components/Unauthorized";
import DashboardNavigator from "./components/DashboardNavigator";
import AddPharmacists from "./pages/pharmacists/Pharmacists/AddPharmacists";
import ViewMedicines from "./pages/pharmacists/Medicines/ViewMedicines";
import CreateBlog from "./pages/pharmacists/Blogs/CreateBlog";
import EditBlog from "./pages/pharmacists/Blogs/EditBlog";
import ViewBlog from "./pages/pharmacists/Blogs/ViewBlog";
import Login from "./pages/guest/Login";
import OTP from "./pages/guest/OTP";
import { PublicRoutes, RoleProtectedRoutes } from "./Guard/ProtectedRoutes";
import AddBranch from "./pages/pharmacists/Pharmacies/AddBranch";
import AddMedicines from "./pages/pharmacists/Medicines/AddMedicines";
import ViewBranch from "./pages/pharmacists/Pharmacies/ViewBranch";
import PharmaciesAdminsList from "./pages/pharmacists/PharmaciesAdminsList/PharmaciesAdminsList";
import OffersList from "./pages/pharmacists/Offers/OffersList";
import Diseases from "./pages/pharmacists/Diseases/Diseases";
import FAQ from "./pages/pharmacists/FAQ/FAQ";
import ResponsiveProvider from "./wrappers/ResponsiveProvider";

function App() {
  return (
    <ResponsiveProvider>
      <Routes>
        {/* Root Path Redirect */}
        <Route path="/" element={<PublicRoutes />} />

        {/* Public Routes */}
        <Route element={<PublicRoutes />}>
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<OTP />} />
        </Route>

        {/* Super Admin Routes */}
        <Route element={<RoleProtectedRoutes allowedRoles={[1]} />}>
          <Route path="/Sadmin" element={<MainLayout />}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/AddPatients" element={<AddPatients />} />
            <Route path="patients/viewPatients/:id" element={<ViewProfile />} />
            <Route path="pharmacies" element={<Pharmacies />} />
            <Route path="pharmacies/AddPharmacy" element={<AddPharmacy />} />
            <Route path="pharmacies/viewPharmacies/:id" element={<ViewProfilePharmacies />} />
            <Route path="pharmacies/AddBranch/:id" element={<AddBranch />} />
            <Route path="pharmacies/ViewBranch/:id" element={<ViewBranch />} />
            <Route path="pharmacists" element={<Pharmacists />} />
            <Route path="pharmacists/AddPharmacists" element={<AddPharmacists />} />
            <Route path="blog" element={<Blogs />} />
            <Route path="blog/CreateBlogs" element={<CreateBlog />} />
            <Route path="blog/EditBlog/:id" element={<EditBlog />} />
            <Route path="blog/ViewBlog/:id" element={<ViewBlog />} />
            <Route path="medicines" element={<Medicines />} />
            <Route path="medicines/AddMedicines" element={<AddMedicines />} />
            <Route path="medicines/ViewMedicines/:id" element={<ViewMedicines />} />
            <Route path="AdminsList" element={<AdminsList />} />
            <Route path="Offers" element={<OffersList />} />
            <Route path="Diseases" element={<Diseases />} />
            <Route path="FAQ" element={<FAQ />} />
            <Route path="PharmaciesAdminsList" element={<PharmaciesAdminsList />} />
          </Route>
        </Route>

        {/* Pharmacy Admin Routes */}
        <Route element={<RoleProtectedRoutes allowedRoles={[4]} />}>
          <Route path="/Padmin" element={<MainLayout />}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/AddPatients" element={<AddPatients />} />
            <Route path="patients/viewPatients/:id" element={<ViewProfile />} />
            <Route path="pharmacies" element={<Pharmacies />} />
            {/* <Route path="pharmacies/AddPharmacy" element={<AddPharmacy />} /> */}
            <Route path="pharmacies/viewPharmacies/:id" element={<ViewProfilePharmacies />} />
            <Route path="pharmacies/AddBranch/:id" element={<AddBranch />} />
            <Route path="pharmacies/ViewBranch/:id" element={<ViewBranch />} />
            <Route path="pharmacists" element={<Pharmacists />} />
            <Route path="pharmacists/AddPharmacists" element={<AddPharmacists />} />
            <Route path="blog" element={<Blogs />} />
            {/* <Route path="blog/CreateBlogs" element={<CreateBlog />} /> */}
            {/* <Route path="blog/EditBlog/:id" element={<EditBlog />} /> */}
            <Route path="blog/ViewBlog/:id" element={<ViewBlog />} />
            <Route path="Offers" element={<OffersList />} />
            <Route path="medicines" element={<Medicines />} />
            <Route path="medicines/ViewMedicines/:id" element={<ViewMedicines />} />
            {/* <Route path="medicines/AddMedicines" element={<AddMedicines />} /> */}
            {/* <Route path="AdminsList" element={<AdminsList />} /> */}
          </Route>
        </Route>

        {/* Pharmacist Routes */}
        <Route element={<RoleProtectedRoutes allowedRoles={[2]} />}>
          <Route path="/pharmacist" element={<MainLayout />}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/AddPatients" element={<AddPatients />} />
            <Route path="patients/viewPatients/:id" element={<ViewProfile />} />
          </Route>
        </Route>

        {/* Default Route */}
        <Route path="*" element={<Unauthorized />} />
      </Routes>
    </ResponsiveProvider>
  );
}

export default App;

